function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

export { _objectWithoutPropertiesLoose as default };
//# sourceMappingURL=objectWithoutPropertiesLoose.js.map
